module.exports = __webpack_public_path__ + "img/Perspektive 10-31-07.4339b1c8.jpg";